import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Application root element was not found");
}

// The critical CSS reveal is injected only into production builds. Remove the
// initial hidden state explicitly so local Vite development cannot render a
// working app that remains invisible behind #root. This is also safe in prod.
root.classList.remove("critical-hidden");

// The service worker is a production feature. Do not register it in local
// development, where an older localhost worker can serve stale JS/API assets.
if (!import.meta.env.PROD && "serviceWorker" in navigator) {
  // Remove workers/caches left by older local builds once, so they cannot
  // intercept Vite requests after this dev-only change is loaded.
  window.addEventListener("load", () => {
    void navigator.serviceWorker.getRegistrations().then((registrations) =>
      Promise.all(registrations.map((registration) => registration.unregister()))
    );
    void caches.keys().then((cacheNames) =>
      Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)))
    );
  });
}

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log(
          "✅ Service Worker registered successfully:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error("❌ Service Worker registration failed:", error);
      });
  });
}

createRoot(root).render(<App />);
